var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "control" },
    [
      _c("multiselect", {
        class: { error: _vm.error },
        attrs: {
          "track-by": "id",
          "custom-label": _vm.fieldLabel,
          options: _vm.users,
          placeholder: _vm.placeholder,
          value: _vm.user,
          searchable: true,
          "deselect-label": "Press enter to clear",
        },
        on: { input: _vm.input },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }